import React from 'react';

const OnlyForSEO = ({ text }) => {
  return <span className="seo-only">{text}</span>;
};

export default OnlyForSEO;

OnlyForSEO.defaultProps = {
  text: 'Ulam Labs'
};
